import React from 'react';

export default function CashOut() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Cash Out</h1>
      <p className="text-gray-500">Halaman Cash Out</p>
    </div>
  );
}
